const PREVIEW_DATA_ATTRIBUTE = "data-content-library-drag-preview";
const PREVIEW_OFFSET = 20;
const PREVIEW_MAX_COUNT = 99;
const CONTENT_LIBRARY_ASSET_WIDTH = 303;
const CONTENT_LIBRARY_ASSET_HEIGHT = 340;
const CONTENT_LIBRARY_ASSET_RATIO = CONTENT_LIBRARY_ASSET_WIDTH / CONTENT_LIBRARY_ASSET_HEIGHT;
const PREVIEW_LAYER_WIDTH = 152;
const PREVIEW_LAYER_HEIGHT = PREVIEW_LAYER_WIDTH / CONTENT_LIBRARY_ASSET_RATIO;
const PREVIEW_LAYER_OFFSETS = [0, 8, 16];
const PREVIEW_ROOT_WIDTH = PREVIEW_LAYER_WIDTH + PREVIEW_LAYER_OFFSETS[2]!;
const PREVIEW_ROOT_HEIGHT = Math.ceil(PREVIEW_LAYER_HEIGHT + 16);

function formatSelectionCount(selectionCount: number): string {
  if (selectionCount > PREVIEW_MAX_COUNT) {
    return `${PREVIEW_MAX_COUNT}+ items`;
  }

  return `${selectionCount} items`;
}

export function setMultiAssetSelectionDragImage({
  dataTransfer,
  selectionCount,
  ownerDocument,
}: {
  dataTransfer: DataTransfer;
  selectionCount: number;
  ownerDocument: Document;
}): (() => void) | undefined {
  if (selectionCount <= 1) {
    return undefined;
  }

  const previewRoot = ownerDocument.createElement("div");
  previewRoot.setAttribute(PREVIEW_DATA_ATTRIBUTE, "true");
  previewRoot.style.position = "fixed";
  previewRoot.style.top = "-10000px";
  previewRoot.style.left = "-10000px";
  previewRoot.style.width = `${PREVIEW_ROOT_WIDTH}px`;
  previewRoot.style.height = `${PREVIEW_ROOT_HEIGHT}px`;
  previewRoot.style.pointerEvents = "none";

  PREVIEW_LAYER_OFFSETS.forEach((leftOffset, index) => {
    const layer = ownerDocument.createElement("div");
    layer.style.position = "absolute";
    layer.style.left = `${leftOffset}px`;
    layer.style.top = `${(PREVIEW_LAYER_OFFSETS.length - 1 - index) * 4}px`;
    layer.style.width = `${PREVIEW_LAYER_WIDTH}px`;
    layer.style.height = `${PREVIEW_LAYER_HEIGHT}px`;
    layer.style.borderRadius = "10px";
    layer.style.border = "1px solid rgba(15, 23, 42, 0.12)";
    layer.style.background = "#ffffff";
    layer.style.boxShadow = "0 8px 20px rgba(15, 23, 42, 0.14)";
    previewRoot.appendChild(layer);
  });

  const countBadge = ownerDocument.createElement("div");
  countBadge.textContent = formatSelectionCount(selectionCount);
  countBadge.style.position = "absolute";
  countBadge.style.right = "0";
  countBadge.style.bottom = "0";
  countBadge.style.borderRadius = "999px";
  countBadge.style.padding = "6px 10px";
  countBadge.style.background = "#1976d2";
  countBadge.style.color = "#ffffff";
  countBadge.style.fontSize = "12px";
  countBadge.style.fontWeight = "600";
  countBadge.style.lineHeight = "1";
  countBadge.style.boxShadow = "0 2px 8px rgba(15, 23, 42, 0.25)";
  previewRoot.appendChild(countBadge);

  ownerDocument.body.appendChild(previewRoot);
  dataTransfer.setDragImage(previewRoot, PREVIEW_OFFSET, PREVIEW_OFFSET);

  return () => {
    if (!previewRoot.isConnected) return;
    previewRoot.remove();
  };
}
